import { render, staticRenderFns } from "./dropDownCase.vue?vue&type=template&id=5980d461&scoped=true"
import script from "./dropDownCase.vue?vue&type=script&lang=js"
export * from "./dropDownCase.vue?vue&type=script&lang=js"
import style0 from "./dropDownCase.vue?vue&type=style&index=0&id=5980d461&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980d461",
  null
  
)

export default component.exports